import React, { useEffect, useState } from "react";
import styles from "./sidebar.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import SidebarC from "common/Sidebar";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";

const Sidebar = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const auth = useAuthUser();

  // Current path
  const currentPath = location.pathname;

  const menuItems = [
    {
      // groupLabel: "Sales",
      items: [
        { label: "Sales", link: "/sales", icon: "salesnew" },
        // { label: "Analytics", link: "/analytics", icon: "analytics" },
        // { label: "Finance", link: "/finance", icon: "financenew" },
      ],
    },
    {
      // groupLabel: "Create",
      items: [
        { label: "Event", link: "/event", icon: "eventnew" },
        { label: "Ticket", link: "/ticket", icon: "ticketnew" },
        { label: "Package", link: "/package", icon: "packagenew" },
        { label: "Ticket Journey", link: "/journey", icon: "ticketnew" },
        { label: "Discount / Referral", link: "/referral", icon: "discountnew" },
      ],
    },
  ];

  if (auth?.role === 'super-admin') {
      menuItems.push({
          items: [
              { label: "Manage Admins", link: "/manage-admins", icon: "discountnew" } 
          ]
      });
  }

  const renderMenuGroup = ({ groupLabel, items }) => (
    <div key={groupLabel}>
      <div className={styles.itemGroup}>{groupLabel}</div>
      {items.map(({ label, link, icon }) => (
        <div
          key={link}
          className={
            link.includes(currentPath) ? styles.itemActive : styles.item
          }
          onClick={() => navigate(link)}
        >
          <img src={`/images/sidebar/${icon}.svg`} alt={`${label} icon`} />
          <span className={styles.itemName}>{label}</span>
        </div>
      ))}
    </div>
  );

  const getMenuItems = () => {
    return (
      <div
        {...props}
        isOpen={true}
     
        className={styles.MenuItems}
      >
        <div
          className={currentPath == "/home" ? styles.itemActive : styles.item}
          onClick={() => navigate("/home")}
        >
        {/* <img src="/images/sidebar/home.svg" alt="Home icon" /> */}
        <img src="https://cdn.prod.website-files.com/66fbdecd7e0c4c4b1e856c81/67beebc184d5764a070459d1_home-icon.svg" alt="Home icon" />
          <span className={styles.itemName}>Home</span>
        </div>
        {menuItems.map(renderMenuGroup)}
        <div
          className={currentPath == "/setting" ? styles.itemActive : styles.item}
          style={{ position: "absolute",bottom:"1rem" }}
          onClick={() => navigate("/setting")}
        >
          {/* <img src="/images/sidebar/setting.svg" alt="Home icon" /> */}
          <img src="https://cdn.prod.website-files.com/66fbdecd7e0c4c4b1e856c81/67beebc1b1f1760bfcd4b078_sales-icon.svg" alt="Home icon" />
          <span className={styles.itemName}>Settings</span>
        </div>
      </div>
    );
  };

  const [isMobile, setIsMobile] = useState(false);

  // Function to detect screen size
  const checkScreenSize = () => {
    setIsMobile(window.matchMedia("(max-width: 800px)").matches);
  };

  useEffect(() => {
    // Initial check
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener("resize", checkScreenSize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return (
    <>
      {isMobile ? (
        <SidebarC child={getMenuItems()} {...props} />
      ) : (
        <div className={styles.MenuWrapper}>
          <div className={styles.withOutMenu}>{getMenuItems()}</div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
